// extracted by mini-css-extract-plugin
export var button = "section-text-module--button--4276d";
export var buttonWrapper = "section-text-module--buttonWrapper--5f03d";
export var primary = "section-text-module--primary--d0e2a";
export var secondary = "section-text-module--secondary--c61bc";
export var sectionText = "section-text-module--sectionText--7bf6b";